import { store } from '@/redux/lib/configureStore';
import { registerModal, unregisterModal } from '@/redux/actions/uiActions/modalActions';
import { modalStackPosition } from '@/redux/selectors/uiSelectors';

export const confirmDialog = async ({ message, confirm, buttons, cancel, title, size, confirmVariant, autoFocus = true, zIndex }) => {
  return new Promise((resolve) => {
    const id = `confirm-dialog-${Math.floor(Math.random() * 10000)}`;
    const backingId = `${id}-backing`;

    let calculatedZIndex;

    if (zIndex !== undefined) {
      calculatedZIndex = zIndex;
    } else {
      store.dispatch(registerModal(id));
      const state = store.getState();
      const stackPosition = modalStackPosition(state, id);
      const baseZIndex = 1200;
      const zIndexIncrement = 10;
      calculatedZIndex = stackPosition >= 0 ? baseZIndex + stackPosition * zIndexIncrement : baseZIndex;
    }

    const template = `
      <div class="confirm-dialog-backing ${backingId}" style="z-index: ${calculatedZIndex}"></div>
      <div class="confirm-dialog ${id} ${size || ''}" style="z-index: ${calculatedZIndex + 1}">
         ${title ? `<div class="title">${title}</div>` : ``}
         <div class="message">${message}</div>
         <div class="buttons ${buttons ? 'multiple' : ''}">
           ${
             cancel !== false
               ? `
               <button class="comp-button" data-action="cancel">
                 <div class="button-main" data-action="cancel">
                  ${cancel || 'Cancel'}
                 </div>
               </button>
             `
               : ''
           }
           ${!buttons ? `<button class="comp-button ${confirmVariant || 'primary'}" data-action="confirm"><div class="button-main" data-action="confirm"><div class="button-label" data-action="confirm">${confirm || 'Confirm'}</div></div></button>` : ``}
           ${
             buttons
               ? `<div class="action-buttons">${Object.entries(buttons)
                   .map(
                     ([key, value], index, array) => `
                <button class="comp-button ${index === array.length - 1 ? 'primary' : ''}" data-action="${key}"><div class="button-main" data-action="${key}">${value}</div></button>
              `
                   )
                   .join('')}
                  </div>`
               : ''
           }
         </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', template);
    const dialog = document.querySelector(`.${id}`);
    const backing = document.querySelector(`.${backingId}`);
    setTimeout(() => {
      dialog.classList.add('active');
      backing.classList.add('active');
      setTimeout(() => {
        const action = buttons ? Object.keys(buttons)[0] : 'confirm';
        const confirmButton = document.body.querySelector(`button[data-action="${action}"]`);
        if (confirmButton && autoFocus) {
          confirmButton.focus();
        }
      }, 300);
    }, 100);
    const close = (confirm) => {
      backing.removeEventListener('click', handleBackingClick);
      dialog.removeEventListener('click', handleButtonClick);
      window.removeEventListener('keydown', handleWindowKeydown);
      dialog.classList.remove('active');
      backing.classList.remove('active');
      resolve(confirm);
      setTimeout(() => {
        dialog.remove();
        backing.remove();
        if (zIndex === undefined) {
          store.dispatch(unregisterModal(id));
        }
      }, 300);
    };
    const handleWindowKeydown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        close(false);
      }
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        e.stopPropagation();
        const cancelButton = document.body.querySelector(`button[data-action="cancel"]`);
        if (cancelButton) {
          cancelButton.focus();
        }
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        e.stopPropagation();
        const action = buttons ? Object.keys(buttons)[0] : 'confirm';
        const confirmButton = document.body.querySelector(`button[data-action="${action}"]`);
        if (confirmButton) {
          confirmButton.focus();
        }
      }
    };
    const handleBackingClick = () => {
      close(false);
    };
    const handleButtonClick = (e) => {
      if (e.target.nodeName === 'BUTTON' || [...e?.target?.classList]?.join('').includes('button')) {
        const action = e.target.getAttribute('data-action');
        const result = action === 'confirm' ? true : action === 'cancel' ? false : action;
        close(result);
      }
    };
    window.addEventListener('keydown', handleWindowKeydown);
    dialog.addEventListener('click', handleButtonClick);
    backing.addEventListener('click', handleBackingClick);
  });
};

export default confirmDialog;
